let hostname: string;
let protocol: string;

if (window.location && window.location.hostname && window.location.protocol) {
  hostname = window.location.hostname.replace(
    /^((bktools(\.in)?)|(dashboard(\.in)?)|bk|app)\./g,
    '',
  );
  ({ protocol } = window.location);
} else {
  hostname = '';
  protocol = '';
}

if (window.BENCH && window.BENCH.hostname) {
  hostname = window.BENCH.hostname; //used for feature deploys
}

const websiteRoot = hostname === 'localhost' || hostname === '' ? '' : `${protocol}//${hostname}`;
const cwa =
  window.BENCH && window.BENCH.cwa_override_url
    ? `${protocol}//${window.BENCH.cwa_override_url}`
    : `${protocol}//app.${hostname}`;
const dashboard =
  window.BENCH && window.BENCH.dashboard_override_url
    ? `${protocol}//${window.BENCH.dashboard_override_url}`
    : `${protocol}//dashboard.in.${hostname}`;
const bkTools =
  window.BENCH && window.BENCH.bktools_override_url
    ? `${protocol}//${window.BENCH.bktools_override_url}/app`
    : `${protocol}//bktools.in.${hostname}/app`;
const billing = `${protocol}//billing.in.${hostname}`;
const apiRoot = `${protocol}//api.${hostname}`;
const categorizerApiPath = '/categorizer/api/';
const nodewayApiPath = '/gateway/web/api/';
const reportingApiPath = '/reports/api/';
const salesforceApiPath = '/salesforce/api/';
const stripeApiPath = '/stripe/api/';

// if hostname contains "10sheet.ca" or "bench.co" (not preceeded by "dev.")
// use the staging/prod domain pattern
const v2Hostname =
  /10sheet\.ca|bench\.co/.test(hostname) && !hostname.includes('dev.bench.co')
    ? `appv2.${hostname}`
    : 'dev.bench.co';

const v2Prefix = window.BENCH?.benchUser ? `${window.BENCH.benchUser}-` : '';
const v2GraphqlRoot = `https://${v2Prefix}graphql.${v2Hostname}/graphql`;
const v2BookkeepingApiRoot = `https://${v2Prefix}bookkeeping.${v2Hostname}`;
const v2FinancialDataApiRoot = `https://${v2Prefix}financial-data.${v2Hostname}`;
const v2TaxApiRoot = `https://${v2Prefix}tax.${v2Hostname}`;

const location = {
  apiRoot,
  v2BookkeepingApiRoot,
  v2FinancialDataApiRoot,
  v2TaxApiRoot,
  bkTools,
  websiteRoot,
  cwa,
  dashboard,
  billing,
  categorizerApiPath,
  nodewayApiPath,
  reportingApiPath,
  salesforceApiPath,
  stripeApiPath,
  v2GraphqlRoot,
};

export default location;
